(function () {
  if (window.__smRv) return;
  window.__smRv = true;
  var NS = 'sm-rv';
  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  function stars(val) {
    var s = el('span', NS + '__stars');
    s.setAttribute('role', 'img');
    s.textContent = '★★★★★';
    var f = el('span', null, '★★★★★');
    f.style.width = Math.max(0, Math.min(100, val * 20)) + '%';
    f.setAttribute('aria-hidden', 'true');
    s.appendChild(f);
    return s;
  }
  function fmtNum(n, lang) {
    try { return n.toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); } catch (e) { return n.toFixed(1).replace('.', ','); }
  }
  function fmtDate(iso, lang) {
    try {
      var p = iso.split('-');
      var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12));
      return d.toLocaleDateString(lang, { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
    } catch (e) { return iso; }
  }
  function init(root, data) {
    var L = root.dataset, lang = L.lang || 'pl', top = root.classList.contains(NS + '--top');
    var translated = L.translated === '1';
    var avgRaw = data.reduce(function (a, r) { return a + r.r; }, 0) / data.length;
    var avg = Math.round(avgRaw * 10) / 10;
    var list = root.querySelector('.' + NS + '__list');
    var more = root.querySelector('.' + NS + '__more');
    var items = data;
    if (top) {
      items = data.filter(function (r) { return r.r === 5 && r.t.length >= 60; }).slice(0, +L.limit || 3);
    }
    var sum = root.querySelector('.' + NS + '__summary');
    if (sum) {
      var a = el('div', NS + '__avg');
      a.appendChild(el('div', NS + '__avg-num', fmtNum(avg, lang)));
      var st = stars(avgRaw);
      st.setAttribute('aria-label', fmtNum(avg, lang) + ' / 5');
      a.appendChild(st);
      a.appendChild(el('div', NS + '__avg-count', L.basedOn.replace('{n}', data.length)));
      sum.appendChild(a);
      var dist = el('div', NS + '__dist');
      for (var s = 5; s >= 1; s--) {
        var c = data.filter(function (r) { return r.r === s; }).length;
        var row = el('div', NS + '__row');
        row.appendChild(el('span', null, s + ' ★'));
        var bar = el('div', NS + '__bar'), fill = el('i');
        fill.style.width = (c / data.length * 100) + '%';
        bar.appendChild(fill);
        row.appendChild(bar);
        row.appendChild(el('b', null, String(c)));
        dist.appendChild(row);
      }
      sum.appendChild(dist);
    }
    function card(r) {
      var c = el('article', NS + '__card');
      var h = el('div', NS + '__head');
      h.appendChild(el('span', NS + '__name', r.n));
      h.appendChild(el('span', NS + '__date', fmtDate(r.d, lang)));
      c.appendChild(h);
      var sr = stars(r.r);
      sr.setAttribute('aria-label', r.r + ' / 5');
      c.appendChild(sr);
      var t = el('p', NS + '__text', r.t);
      if (r.t) c.appendChild(t);
      if (translated && r.o && !top) {
        var tr = el('div', NS + '__tr');
        tr.appendChild(el('span', null, L.translatedLabel));
        var b = el('button', NS + '__toggle', L.showOriginal);
        b.type = 'button';
        var showing = false;
        b.addEventListener('click', function () {
          showing = !showing;
          t.textContent = showing ? r.o : r.t;
          t.setAttribute('lang', showing ? 'pl' : lang);
          b.textContent = showing ? L.showTranslation : L.showOriginal;
        });
        tr.appendChild(b);
        c.appendChild(tr);
      }
      return c;
    }
    var shown = 0, step = top ? items.length : (+L.step || 8);
    function render() {
      var end = Math.min(items.length, shown + step);
      for (; shown < end; shown++) list.appendChild(card(items[shown]));
      if (more) more.hidden = shown >= items.length;
    }
    if (more) more.addEventListener('click', render);
    render();
  }
  function boot() {
    var roots = document.querySelectorAll('.' + NS + '[data-sm-rv]');
    if (!roots.length) return;
    var node = document.getElementById('sm-rv-data'), data;
    try { data = JSON.parse(node.textContent); } catch (e) { return; }
    if (!data || !data.length) return;
    Array.prototype.forEach.call(roots, function (r) { init(r, data); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
